module.exports = __webpack_public_path__ + "static/media/logo_circle.d9aeaa67.png";